import Logo from "../../../../public/images/icon-guten.svg";

const Block_Logo = () => (
    <div>
        <Logo />
    </div>
);

export default Block_Logo;
